var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "deals-menu" }, [
    _c(
      "div",
      { staticClass: "extended-block" },
      [
        _c("h6", [_vm._v("Diligence")]),
        _vm._v(" "),
        _vm.isCipeEnabled
          ? _c("menu-item", {
              attrs: {
                path: "/matching/ethics-1st",
                text: "Ethics 1st",
                caption:
                  "Ethics 1st is a platform for African businesses looking to build global recognition and gain trust with global investors and business partners",
              },
              on: {
                click: function ($event) {
                  return _vm.handleItemClick("/matching/ethics-1st")
                },
              },
            })
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "extended-block" },
      [
        _c("h6", [_vm._v("Deals")]),
        _vm._v(" "),
        _c("menu-item", {
          attrs: {
            path: "/matching/marketplaces",
            text: "DealRooms",
            caption: "Finance & Invest in African (High-Growth) Companies",
          },
          on: {
            click: function ($event) {
              return _vm.handleItemClick("/matching/marketplaces")
            },
          },
        }),
        _vm._v(" "),
        _c("menu-item", {
          attrs: {
            path: "/deals/gabon-virtual-dealroom/investor",
            text: "Gabon VDR",
            caption:
              "The Gabon VDR initiative aims to encourage private investors focused on the African continent to seize the many business opportunities in Gabon",
          },
          on: {
            click: function ($event) {
              return _vm.handleItemClick(
                "/deals/gabon-virtual-dealroom/investor"
              )
            },
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }